<div class="container-fluid" *ngIf="isSpotter">
  <div class="row dashboardRow" >
    <div class="col-md-6 header" style="position:relative">
      <h4><b>{{ 'common.dashboard'  | translate}}</b></h4>
      <!-- <i class="armx-icon  armx-calendar" style="position: absolute;
    z-index: 99;
    cursor:pointer;
    left: 280px;
    top: 75px;
    color: #dc291e;" (click)="openCelender($event);$event.stopPropagation()"></i>
      <ng-datepicker (ngModelChange)="modelChanged($event)" [(ngModel)]="date" [options]="dateOptions"></ng-datepicker> -->
      <input matInput [matDatepicker]="date"> 
      <mat-datepicker-toggle matIconSuffix [for]="date"></mat-datepicker-toggle>
      <mat-datepicker #date></mat-datepicker> 
    </div>
    <div class="col-md-6 header" *ngIf="showConfirmCode == true" style="position:relative">
      <a routerLink="/dashboard/confirm-using-qr-code" class="btn btn-primary pull-right" style="margin-top: 46px;"> <img width="25" src="../assets/img/qr.svg"> {{ 'common.confirmUsingQRCode'  | translate}}</a>
    </div>
  </div>
  <br />
  <div class="row">
    <dashboard-cards [options]="card1options" [marginTop]="marginTop" width="90"></dashboard-cards>
    <dashboard-cards [options]="card2options" ></dashboard-cards>
    <dashboard-cards [options]="card3options"></dashboard-cards>
  </div>
  <div class="row">
    <dashboard-tabel [options]="table1"></dashboard-tabel>
    <dashboard-tabel [options]="table2"></dashboard-tabel>
  </div>
</div>

